import ACTIONS, { FETCH_STATUS } from "../constants";

export const getProgramsRequestAttempt = {
  pending: {
    type: ACTIONS.PROGRAMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROGRAMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROGRAMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getProgramsRequest = (state) => ({
  type: ACTIONS.PROGRAMS_CALL,
  payload: state,
});

export const sortProgramsRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_PROGRAMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_PROGRAMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_PROGRAMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortProgramsRequest = (state) => ({
  type: ACTIONS.SORT_PROGRAMS_CALL,
  payload: state,
});

export const createProgramsAttempt = {
  pending: {
    type: ACTIONS.CREATE_PROGRAMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_PROGRAMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_PROGRAMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createProgramsRequest = (state) => ({
  type: ACTIONS.CREATE_PROGRAMS_CALL,
  payload: state,
});

export const updateProgramsAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PROGRAMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PROGRAMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PROGRAMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateProgramsRequest = (state) => ({
  type: ACTIONS.UPDATE_PROGRAMS_CALL,
  payload: state,
});

export const deleteProgramsAttempt = {
  pending: {
    type: ACTIONS.DELETE_PROGRAMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_PROGRAMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_PROGRAMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteProgramsRequest = (state) => ({
  type: ACTIONS.DELETE_PROGRAMS_CALL,
  payload: state,
});

export const getProgramDetailsAttempt = {
  pending: {
    type: ACTIONS.GET_PROGRAM_DETAILS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROGRAM_DETAILS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROGRAM_DETAILS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getProgramDetails = (state) => ({
  type: ACTIONS.GET_PROGRAM_DETAILS_CALL,
  payload: state,
});

// program budget summary
export const getProgramBudgetSummaryAttempt = {
  pending: {
    type: ACTIONS.GET_PROGRAM_BUDGET_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROGRAM_BUDGET_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROGRAM_BUDGET_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getProgramBudgetSummary = (state) => ({
  type: ACTIONS.GET_PROGRAM_BUDGET_SUMMARY_CALL,
  payload: state,
});
// program progress summary
export const getProgramProgressSummaryAttempt = {
  pending: {
    type: ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getProgramProgressSummary = (state) => ({
  type: ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY_CALL,
  payload: state,
});

export const updateProgramFlagAttempt = {
  pending: {
    type: ACTIONS.PROGRAM_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROGRAM_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROGRAM_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateProgramFlag = (state) => ({
  type: ACTIONS.PROGRAM_FLAG_CALL,
  payload: state,
});

export const getProgressTracker = (state) => ({
  type: ACTIONS.PROGRESS_TRACKER_CALL,
  payload: state,
});

export const getProgressTrackerAttempt = {
  pending: {
    type: ACTIONS.PROGRESS_TRACKER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROGRESS_TRACKER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROGRESS_TRACKER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateProgressKPI = (state) => ({
  type: ACTIONS.UPDATE_PROGRESS_KPI_CALL,
  payload: state,
});

export const updateProgressKPIAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PROGRESS_KPI.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PROGRESS_KPI.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PROGRESS_KPI.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const filterProgressTracker = (state) => ({
  type: ACTIONS.PROGRESS_TRACKER_FILTER_CALL,
  payload: state,
});

export const filterProgressTrackerAttempt = {
  pending: {
    type: ACTIONS.PROGRESS_TRACKER_FILTER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROGRESS_TRACKER_FILTER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROGRESS_TRACKER_FILTER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const ProgramStatusReportRequestAttempt = {
  pending: {
    type: ACTIONS.PROGRAM_STATUS_REPORT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PROGRAM_STATUS_REPORT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PROGRAM_STATUS_REPORT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const ProgramStatusReportRequest = (state) => ({
  type: ACTIONS.PROGRAM_STATUS_REPORT_CALL,
  payload: state,
});

export const ProgramClearReportRequest = () => ({
  type: ACTIONS.PROGRAM_CLEAR_STATUS_REPORT,
});